import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const statusMap = {
  INACTIVE: 'BLOCKED',
}

const responseParser = ({ data }: any) => {
  let parsedData = data?.entityUserJoinList
  let modArray: any = []
  parsedData.map((dataObj: any) => {
    modArray?.push({
      email: dataObj?.emailId ?? '',
      createdDate: dataObj?.createdAt ?? '',
      status: statusMap[dataObj?.status as keyof typeof statusMap] ?? dataObj?.status ?? '',
      jfsUserId: dataObj?.jfsUserId ?? '',
      entityType: dataObj?.entityType ?? '',
      accessProfileId: dataObj?.accessProfileId ?? '',
      //
      isDefault: dataObj?.isDefault ?? '',
      entityId: dataObj?.entityId ?? '',
      accessRights: dataObj?.accessRights ?? [],
      id: dataObj?.jfsUserId ?? '',
      lastLogin: dataObj?.lastLogin ?? '',
      department: dataObj?.department ?? '',
      userType: dataObj?.userType ?? '',
      user: dataObj?.user ?? null,
    })
  })
  return modArray
}

const returnPostData = (postData: any) => {
  return postData
}

const getUsers = (tokens: any, postData: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getUsers,
    method: 'POST',
    body: returnPostData(postData),
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getUsers }
